import { useEffect, useState } from 'react';

interface ArticleTocProps {
  paragraphs: string[];
}

export default function ArticleToc({ paragraphs }: ArticleTocProps) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      let current = 0;
      paragraphs.forEach((_, index) => {
        const el = document.getElementById(`paragraph-${index}`);
        if (el && el.getBoundingClientRect().top < 180) {
          current = index;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [paragraphs]);

  const goTo = (index: number) => {
    const el = document.getElementById(`paragraph-${index}`);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <nav className="rounded-lg border border-background-200/70 bg-background-100/50 p-5" aria-label="内容目录">
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <i className="ri-list-check-2 text-accent-400" />
        内容目录
      </h2>
      <ol className="mt-4 space-y-1">
        {paragraphs.map((text, index) => (
          <li key={`toc-${index}`}>
            <button
              type="button"
              onClick={() => goTo(index)}
              className={`flex w-full cursor-pointer items-start gap-2.5 rounded-md px-2.5 py-2 text-left text-xs leading-relaxed transition-colors ${
                active === index
                  ? 'bg-primary-500/12 text-primary-200'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              <span className="font-label tabular-nums text-foreground-500">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="line-clamp-2">{text.slice(0, 18)}</span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}